import React, { useState, useEffect } from "react";
import { Hotel, Key, Edit2, Save, X } from "lucide-react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function RoomNumberCard() {
  const [isEditing, setIsEditing] = useState(false);
  // ✅ 修改 1: 初始狀態只留 room1 和 room2
  const [rooms, setRooms] = useState({
    room1: "",
    room2: "",
  });
  const [tempRooms, setTempRooms] = useState(rooms);

  // 讀取資料
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const docRef = doc(db, "tripData", "rooms");
        const docSnap = getDoc(docRef);

        if ((await docSnap).exists()) {
          // 只讀取前兩間的資料
          const data = (await docSnap).data();
          setRooms({
            room1: data.room1 || "",
            room2: data.room2 || "",
          });
        }
      } catch (error) {
        console.error("Error fetching rooms:", error);
      }
    };
    fetchRooms();
  }, []);

  // 開啟編輯模式
  const handleEdit = () => {
    setTempRooms(rooms);
    setIsEditing(true);
  };

  // 儲存資料
  const handleSave = async () => {
    try {
      const docRef = doc(db, "tripData", "rooms");
      await setDoc(docRef, tempRooms, { merge: true });

      setRooms(tempRooms);
      setIsEditing(false);
    } catch (error) {
      console.error("Error saving rooms:", error);
      alert("儲存失敗，請檢查網路");
    }
  };

  return (
    <div className="bg-[#fbf8f1] rounded-2xl p-6 shadow-sm border border-[#e6e2d6] mb-6">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <Hotel className="w-5 h-5 text-[#1e3932]" />
          <h2 className="text-lg font-bold text-[#1e3932]">住宿房號紀錄</h2>
        </div>
        {!isEditing ? (
          <button
            onClick={handleEdit}
            className="flex items-center gap-1 text-sm text-[#8c7851] bg-[#f0ebe0] px-3 py-1.5 rounded-full hover:bg-[#e6e2d6] transition-colors"
          >
            <Edit2 size={14} />
            編輯
          </button>
        ) : (
          <div className="flex gap-2">
            <button
              onClick={() => setIsEditing(false)}
              className="p-1.5 text-gray-500 hover:bg-gray-100 rounded-full"
            >
              <X size={18} />
            </button>
            <button
              onClick={handleSave}
              className="flex items-center gap-1 text-sm text-white bg-[#1e3932] px-3 py-1.5 rounded-full hover:bg-[#142621]"
            >
              <Save size={14} />
              儲存
            </button>
          </div>
        )}
      </div>

      {/* ✅ 修改 2: 這裡改成 grid-cols-2 (原本是 3) */}
      <div className="grid grid-cols-2 gap-4">
        {/* ROOM 1 */}
        <div className="bg-white p-3 rounded-xl border border-dashed border-[#d4cdb8]">
          <span className="text-[10px] font-bold text-[#8c7851] tracking-wider block mb-1">
            ROOM 1
          </span>
          <div className="flex items-center gap-2">
            <Key className="w-4 h-4 text-[#d4cdb8]" />
            {isEditing ? (
              <input
                type="text"
                value={tempRooms.room1}
                onChange={(e) =>
                  setTempRooms({ ...tempRooms, room1: e.target.value })
                }
                className="w-full bg-[#f9f9f9] border-b border-[#8c7851] text-[#1e3932] font-mono text-lg outline-none pb-0.5"
                placeholder="---"
              />
            ) : (
              <span className="text-xl font-mono text-[#1e3932] font-bold">
                {rooms.room1 || "---"}
              </span>
            )}
          </div>
        </div>

        {/* ROOM 2 */}
        <div className="bg-white p-3 rounded-xl border border-dashed border-[#d4cdb8]">
          <span className="text-[10px] font-bold text-[#8c7851] tracking-wider block mb-1">
            ROOM 2
          </span>
          <div className="flex items-center gap-2">
            <Key className="w-4 h-4 text-[#d4cdb8]" />
            {isEditing ? (
              <input
                type="text"
                value={tempRooms.room2}
                onChange={(e) =>
                  setTempRooms({ ...tempRooms, room2: e.target.value })
                }
                className="w-full bg-[#f9f9f9] border-b border-[#8c7851] text-[#1e3932] font-mono text-lg outline-none pb-0.5"
                placeholder="---"
              />
            ) : (
              <span className="text-xl font-mono text-[#1e3932] font-bold">
                {rooms.room2 || "---"}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
